import React, { FC } from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import Image from 'frontastic/lib/image';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { mediumDesktop, tablet } from 'helpers/utils/screensizes';
import usePreloadImages from 'helpers/hooks/usePreloadImages';

export interface Props {
  logo: any;
  logoLink: string;
  imageClassName?: string;
  onClick?: () => void;
}

const HeaderLogo: FC<Props> = ({ logoLink, logo, imageClassName, onClick }) => {
  const [isDesktop] = useMediaQuery(tablet);
  usePreloadImages([logo]);
  return (
    <div className="relative md:mt-0" onClick={onClick}>
      <Link className={imageClassName} link={logoLink}>
        <Image
          src={logo?.url}
          alt={logo?.description}
          fill
          style={{ objectFit: 'contain' }}
          priority
          loading="eager"
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        />
      </Link>
    </div>
  );
};

export default HeaderLogo;
